import UserDetails from './userDetails';

export default UserDetails;
